module.exports = __webpack_public_path__ + "img/ic_room_customer_right_img1.7f65bcc7.png";